import ArrowDropDown from '@material-ui/icons/ArrowDropDown'
import ArrowDropUp from '@material-ui/icons/ArrowDropUp'
import React from 'react'
import ReactPaginate from 'react-paginate'
import FetchData from '../../shared/fetchData'
import { checkValidity, updateObject } from '../../shared/utility'
import Alert from '../UI/Alert/Alert'
import Button from '../UI/Button/Button'
import Input from '../UI/Input/Input'
import Modal from '../UI/Modal/Modal'
import Select from '../UI/Select/Select'
import History from './History/History'
import './OrderForEvacuation.css'
import Password from './Password/Password'
import PasswordReq from './PasswordReq/PasswordReq'

const OrderForEvacuation = (props) => {

    const [loading, setLoading] = React.useState(false)
    const [showError, setShowError] = React.useState(false)
    const [errorContent, setErrorContent] = React.useState('')
    const [showAlert, setShowAlert] = React.useState(false)
    const [alertContent, setAlertContent] = React.useState('')
    const [cancelReasons, setCancelReasons] = React.useState([])
    const [histories, setHistories] = React.useState([])
    const [passwords, setPasswords] = React.useState([])
    const [cancelReason, setCancelReason] = React.useState('')
    const [hasError, setHasError] = React.useState(false)
    const [error, setError] = React.useState('')
    const [orderNumber, setOrderNumber] = React.useState('')
    const [invalidSelect, setInvalidSelect] = React.useState(false)
    const [offset, setOffset] = React.useState('1')
    const [perPage, setPerPage] = React.useState('3')
    const [pageCount, setPageCount] = React.useState('0')
    const [orderId, setOrderId] = React.useState('')
    const [searchPass, setSearchPass] = React.useState({
        password: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'جستجو'
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        }
    })

    const childRef = React.useRef();
    const historyRef = React.useRef();
    const passwordRef = React.useRef();
    const passwordsRef = React.useRef();
    React.useEffect(() => {
        var info = {
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/orders/getCancelReasons'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setCancelReasons(result.cancelReasons)
            })
            .catch(error => console.log(error))
    }, [])
    const inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(searchPass, {
            [controlName]: updateObject(searchPass[controlName], {
                value: event.target.value,
                valid: checkValidity(event.target.value, searchPass[controlName].validation)
            })
        });
        setSearchPass(updatedControls)
    }

    const cancelOrder = (event) => {
        setHasError(false)
        setError('')
        setCancelReason('')
        childRef.current.openModal()
    }

    const showHistoriesHandler = (event, orderId) => {
        var info = {
            "order": {
                "id": orderId,
            },
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/orders/getOrderInfo'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0 && result.order.histories != null) {
                    setHistories(result.order.histories)
                }
                setLoading(false)
            })
            .catch(error => setLoading(false))
        historyRef.current.openModal()
    }
    const closeModal = (event) => {
        childRef.current.closeModal()
    }
    const changeCancelReason = (selectedOption) => {
        setCancelReason(selectedOption)
    }
    const cancelOrderSubmit = (event) => {
        let valid = true
        if (cancelReason == null || cancelReason == '') {
            valid = false
            setInvalidSelect(true)
        }
        if (valid) {
            var info = {
                "orderId": props.order.id,
                "reasonId": cancelReason != null && cancelReason != '' ? cancelReason.value : '',
                "version": "mtpx001"
            }
            var raw = JSON.stringify(info)
            var url = 'management/api/v1/orders/cancelOrder'
            FetchData(raw, url).then(response => response.json())
                .then(result => {
                    if (result.status == 0) {
                        childRef.current.closeModal()
                        props.updateGrid()
                    } else {
                        let err = ''
                        if (result.message == 'INVALID_INPUT') {
                            err = 'اطلاعات معتبر نیست'
                        } else if (result.message == 'TIMEOUT_CANCEL') {
                            err = 'مهلت کنسل کردن سفارش گذشته است'
                        } else if (result.message == 'INVALID_STATE') {
                            err = 'وضعیت سفارش صحیح نیست'
                        }
                        setHasError(true)
                        setError(err)
                    }
                })
                .catch(error => console.log(error))
        }
    }
    const passwordRequest = (event, ordNumber) => {
        setOrderNumber(ordNumber)
        passwordRef.current.openModal()
    }
    const showPasswords = (event, ordId) => {
        setOrderId(ordId)
        var info = {
            "orderId": ordId,
            "pl": 3,
            "pn": 1,
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/orders/getOrderPasswords'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setPasswords(result.passwords)
                setPageCount(result.count / parseInt(perPage))
                passwordsRef.current.openModal()
            })
            .catch(error => console.log(error))
    }
    const handlePageClick = (e) => {
        setOffset(e.selected + 1)
        var info = {
            "orderId": orderId,
            "password": searchPass.password.value != '' ? searchPass.password.value : null,
            "pl": perPage,
            "pn": e.selected + 1,
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/orders/getOrderPasswords'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setPasswords(result.passwords)
                setPageCount(result.count / parseInt(perPage))
            })
            .catch(error => console.log(error))
    }
    const reloadPasswords = (e) => {
        var info = {
            "orderId": orderId,
            "password": searchPass.password.value != '' ? searchPass.password.value : null,
            "pl": perPage,
            "pn": offset,
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/orders/getOrderPasswords'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setPasswords(result.passwords)
                setPageCount(result.count / parseInt(perPage))
            })
            .catch(error => console.log(error))
    }

    const closePasswordModal = (event) => {
        passwordRef.current.closeModal()
    }

    const closePasswordsModal = (event) => {
        passwordsRef.current.closeModal()
    }

    const afterCloseModal = (event) => {
    }
    const putError = (event, value) => {
        setShowError(value)
        setErrorContent('وضعیت سفارش صحیح نیست')
    }

    const searchPasswords = (event) => {
        var info = {
            "orderId": orderId,
            "password": searchPass.password.value != '' ? searchPass.password.value : null,
            "pl": perPage,
            "pn": "1",
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/orders/getOrderPasswords'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setPasswords(result.passwords)
                setPageCount(result.count / parseInt(perPage))
            })
            .catch(error => console.log(error))
    }
    const arrowClass = props.order.parcels !== null ? <ArrowDropUp className="OrderIcon" /> : <ArrowDropDown className="OrderIcon" />

    let reasonList = []
    if (cancelReasons != null && cancelReasons.length != 0) {
        cancelReasons.map(b => {
            reasonList.push({
                value: b.id,
                label: b.description
            })
        })
    }
    const historyContent = histories != null && histories.length != 0 && !loading ? histories.map(h => {
        return <History history={h} />
    })
        :
        (!loading ?
            <div className="row justify-content-center w-100">
                <div className='empty-trns'>
                    هیچ تراکنشی وجود ندارد!
                </div>
            </div>
            : '')
    const modalContent = !hasError ? <div>
        <div className="row justify-content-center">
            <Select
                name="form-field-name"
                value={cancelReason}
                placeholder="علت کنسلی"
                inModal={true}
                className={invalidSelect && (cancelReason == null || cancelReason == '') ? 'invalid-select' : ''}
                options={reasonList}
                onChange={changeCancelReason}
                col="12"
            />
        </div>
        <div className="row justify-content-center mt-3">
            <div className="col-6">
                <Button btnType="General" clicked={closeModal} >خیر</Button>
            </div>
            <div className="col-6">
                <Button btnType="Success" clicked={cancelOrderSubmit} >بله</Button>
            </div>
        </div>
    </div>
        : <div>
            <div className="row justify-content-center">
                {error}
            </div>
            <div className="row justify-content-center mt-3">
                <Button btnType="General" clicked={closeModal} >بستن</Button>
            </div>
        </div>
    const formElementsArray = [];
    for (let key in searchPass) {
        formElementsArray.push({
            id: key,
            config: searchPass[key]
        });
    }
    let form = formElementsArray.map(formElement => {
        return (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                placeholder={formElement.config.placeholder}
                errorMessage={formElement.config.errorMessage}
                col="4 p-0 mt-3"
                changed={(event) => inputChangedHandler(event, formElement.id)} />
        );
    });
    const passwordContent = <PasswordReq putError={putError} closeModal={closePasswordModal} orderNumber={orderNumber} />
    const passwordsContent =
        <div className="pass-container">
            <div className="row justify-content-center mr-0 ml-0 mt-3">
                {form}
                <div className="col-4 p-0 mt-3">
                    <Button className="pass-search" btnType="Success" clicked={searchPasswords} >جستجو</Button>
                </div>
            </div>
            {passwords != null && passwords.length != 0 ?
                passwords.map(p => {
                    return (
                        <div className="row justify-content-center mt-3">
                            <Password reloadPasswords={reloadPasswords} password={p} closeModal={closePasswordsModal} />
                        </div>
                    )
                })
                :
                <div className="row justify-content-center mt-3 mb-3">
                    هیچ رمزی یافت نشد!
                </div>
            }
            {passwords != null && passwords.length != 0 ?
                <div className="row justify-content-center">
                    <ReactPaginate
                        previousLabel={"→قبلی"}
                        nextLabel={"بعدی←"}
                        forcePage={offset >= 0 ? offset - 1 : offset}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName="pagination"
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"} />
                </div>
                : ''}
        </div>

    return (
        <div className="nav-cntnr">
            <div className="row justify-content-center">
                <div className="order-cntnr mt-3">
                    <div className="row pr-3">
                        <div className="ord-num small-ord-col">
                            {props.order.orderNumber}
                        </div>
                    </div>
                    <div className="row justify-content-center mt-3">
                        <div className="col-10">
                            <div className="row justify-content-center">
                                <div className="col-2 small-ord-col">
                                    تاریخ ثبت:
                                </div>
                                <div className="col-2 small-ord-col">
                                    {props.order.cancelReason}
                                    {props.order.registerDate}
                                </div>
                                <div className="col-2 small-ord-col">
                                    از تاریخ:
                                </div>
                                <div className="col-2 small-ord-col">
                                    {props.order.startDate}
                                </div>
                                <div className="col-2 small-ord-col">
                                    تا تاریخ:
                                </div>
                                <div className="col-2 small-ord-col">
                                    {props.order.endDate}
                                </div>
                            </div>
                            <div className="row justify-content-center mt-3">
                                <div className="col-2 small-ord-col">
                                    سفارش دهنده:
                                </div>
                                <div class="col-2 small-ord-col">
                                    {props.order.unit != null ? props.order.unit.unitName : '-'}
                                </div>
                                <div className="col-2 small-ord-col">
                                    از ساعت :
                                </div>
                                <div className="col-2 small-ord-col">
                                    {props.order.startTime}
                                </div>
                                <div className="col-2 small-ord-col">
                                    تا ساعت:
                                </div>
                                <div className="col-2 small-ord-col">
                                    {props.order.endTime}
                                </div>
                            </div>
                            <div className="row justify-content-center mt-3">
                                <div class="col-2 small-ord-col">
                                    هزینه باکس:
                                </div>
                                <div class="col-2 small-ord-col">
                                    {props.order.lockerAmount != null && props.order.lockerAmount !== '' ? props.order.lockerAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '-'} ريال
                                </div>
                                <div class="col-2 small-ord-col">
                                    مالیات:
                                </div>
                                <div class="col-2 small-ord-col">
                                    {props.order.taxAmount != null && props.order.taxAmount !== '' ? props.order.taxAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '-'} ريال
                                </div>
                                <div class="col-2 small-ord-col">
                                    هزینه نهایی:
                                </div>
                                <div class="col-2 small-ord-col">
                                    {props.order.finalAmount != null && props.order.finalAmount !== '' ? props.order.finalAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '-'} ريال
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div class="col-2 small-ord-col">
                                    سریال باکس:
                                </div>
                                <div class="col-2 small-ord-col">
                                    {props.order.locker != null ? props.order.locker.serial : ''}
                                </div>
                                <div class="col-2 small-ord-col">
                                    نام باکس:
                                </div>
                                <div class="col-2 small-ord-col">
                                    {props.order.kiosk != null ? props.order.kiosk.description : ''}
                                </div>
                                <div class="col-2 small-ord-col">
                                    شناسه سفارش دهنده:
                                </div>
                                <div class="col-2 small-ord-col">
                                    {props.order.courierTrackNumber != null ? props.order.courierTrackNumber : ''}
                                </div>
                            </div>
                            <hr />
                            <div className="row mt-3" dir="ltr">
                                <div className="col-3 hulf-small">
                                    <Button btnType="General" clicked={cancelOrder} >کنسل کردن</Button>
                                </div>
                                <div className="col-3 hulf-small">
                                    <Button btnType="General" clicked={(event) => showHistoriesHandler(event, props.order.id)}>مشاهده تاریخچه</Button>
                                </div>
                                <div className="col-3 hulf-small">
                                    <Button btnType="General" clicked={(event) => passwordRequest(event, props.order.orderNumber)}>درخواست رمز</Button>
                                </div>
                                <div className="col-3 hulf-small">
                                    <Button btnType="General" clicked={(event) => showPasswords(event, props.order.id)}>مشاهده رمز</Button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row justify-content-center">
                        <Modal
                            content={modalContent}
                            ref={childRef}
                            closePermission="true"
                            closeModal={(event) => afterCloseModal(event)}
                        />
                        <Modal
                            content={historyContent}
                            ref={historyRef}
                            closePermission="true"
                            closeModal={(event) => afterCloseModal(event)}
                        />
                        <Modal
                            content={passwordContent}
                            ref={passwordRef}
                            closePermission="true"
                            closeModal={(event) => afterCloseModal(event)}
                        />
                        <Modal
                            content={passwordsContent}
                            ref={passwordsRef}
                            closePermission="true"
                            closeModal={(event) => afterCloseModal(event)}
                        />
                    </div>
                    {showError == true ?
                        <div class="row justify-content-center mt-5 alert-cntnr">
                            <Alert variant="error" class="mt-3" text={errorContent} />
                        </div>
                        : ''}
                    {showAlert == true ?
                        <div class="row justify-content-center mt-5 alert-cntnr">
                            <Alert variant="success" class="mt-3" text={alertContent} />
                        </div>
                        : ''}
                </div>
            </div>
        </div>
    )
}
export default OrderForEvacuation